import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { openSnackbar } from '@/core/features/snackbar';
import { closeDrawer } from '@/core/features/drawer';
import { createMemberRequest } from '@/api/members';
import i18n from '@/i18n';
import { createMember, fetchMembers } from '../actions';

const createMemberEpic: Epic = (action$) =>
  action$.pipe(
    filter(createMember.match),
    request(({ payload }) => createMemberRequest(payload), createMember),
  );

const createMemberSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(createMember.succeeded.match),
    mergeMap(
      ({
        payload: {
          originalData: { propertyId },
        },
      }) => [
        closeDrawer(),
        openSnackbar({
          snackbarType: 'success',
          snackbarMessage: i18n.t('CREATE_MEMBER_SUCCESS'),
        }),
        fetchMembers({ propertyId }),
      ],
    ),
  );

export default combineEpics(createMemberEpic, createMemberSucceededEpic);
